import React, { useContext, useState } from 'react';
import { Parallax } from "react-parallax";
import { Link } from "react-router-dom";
import { AppContext } from '../main';


const Section = (props) => {
  const {
    handleEditItem
  } = props

  const { appState
  } = useContext(AppContext);
  const {
    marquees = {}
    , editMode = false
  } = appState

  if (!marquees?.locations) {
    return null
  }

  return <div className="no-bottom wow fadeInRight d-flex z-1000">
    <div className="de-marquee-list s2 wow">
      <div className="d-item">
        {marquees.locations.map((location, index) => (
          <React.Fragment key={index}>
            <span className="d-item-txt">
              <img src={location.flag} alt={location.name} /> {location.name}
            </span>
            <span className="d-item-display">
              <i className="d-item-block"></i>
            </span>
          </React.Fragment>
        ))}
      </div>
    </div>
  </div>
};

export default Section;
